export const NAV_EDIT_BUTTON = 'nav_edit_button' as string;
export const NAV_DONE_BUTTON = 'nav_done_button' as string;
export const WEEK_SHOW_WEEKS = 'week_show_weeks' as string;
export const SHOW_MODAL = 'show_modal' as string;
export const SHOW_MESSAGE = 'show_message' as string;
export const SET_THEME = 'set_theme' as string;
export const TAP_EDIT_BUTTON = 'tap_edit_button' as string;